import { observer } from 'mobx-react-lite'

import { StoreReturnsSettings, MsStoresLoadingProps } from '../StoreReturnsSettings'

import { useApi } from '../../../hooks/storeHook'
import { useOzonAccount } from '../../../hooks/routeHooks'

export const OzonReturnsSettings =
  observer(({msStores, loadMsStores}: MsStoresLoadingProps) => {
    const {userSync: {setOzonReturnsSettings}} = useApi()
    const account = useOzonAccount()

    return (
      <StoreReturnsSettings
        title="НАСТРОЙКИ ВОЗВРАТОВ"
        msStores={msStores}
        loadMsStores={loadMsStores}
        account={account}
        saveSettings={setOzonReturnsSettings}
      />
    )
  })